module.exports = __webpack_public_path__ + "static/img/glove_none.d24eb54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_none.png
// module id = +Nl3
// module chunks = 0